module.exports = __webpack_public_path__ + "img/map_placeholder.4e0a30fc.png";